// =============================================================================
// ACCORDION — FAQ section expand/collapse
// Each .accordion__item toggles open/closed via the --open modifier class.
// Keyboard: Enter/Space to toggle; arrow keys to move between items.
// WCAG 4.1.2 — Name, Role, Value; 2.1.1 — Keyboard accessible ✓
// =============================================================================

function initAccordion(container) {
  const items = container.querySelectorAll('.accordion__item');

  items.forEach((item) => {
    const header = item.querySelector('.accordion__header');
    const body   = item.querySelector('.accordion__body');
    const id     = `accordion-body-${Math.random().toString(36).slice(2, 8)}`;

    if (!header || !body) return;

    // Set up ARIA attributes
    header.setAttribute('aria-expanded', 'false');
    header.setAttribute('aria-controls', id);
    body.setAttribute('id', id);
    body.setAttribute('role', 'region');

    header.addEventListener('click', () => toggleItem(item));
    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleItem(item);
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusAdjacentItem(items, item, 1);
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusAdjacentItem(items, item, -1);
      }
    });
  });

  function toggleItem(item) {
    const isOpen = item.classList.contains('accordion__item--open');

    // Close all other items
    items.forEach((other) => {
      if (other !== item) {
        other.classList.remove('accordion__item--open');
        other.querySelector('.accordion__header')?.setAttribute('aria-expanded', 'false');
      }
    });

    const header = item.querySelector('.accordion__header');
    item.classList.toggle('accordion__item--open', !isOpen);
    header.setAttribute('aria-expanded', String(!isOpen));
  }

  function focusAdjacentItem(all, current, direction) {
    const arr = Array.from(all);
    const idx = arr.indexOf(current);
    const next = arr[idx + direction];
    if (next) next.querySelector('.accordion__header')?.focus();
  }
}

// Initialise all accordion containers on the page
document.querySelectorAll('.accordion').forEach(initAccordion);
